<template>
  <div class="w-full flex">
    <!--    <BaseSidebar />-->

    <span id="top-element" />
    <div class="w-full min-h-screen grid grid-rows-[min-content_1fr]">
      <BaseHeader
        :user="authStore.user"
        v-bind="{ activeRoute }"
        v-on="{ logout }"
      />

      <div class="h-full w-full bg-gray-100 px-5 sm:px-32 py-8">
        <slot />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>

import { useAuthStore } from "@/modules/Authorization/store";
import BaseHeader from "@/components/Base/Header/BaseHeader.vue";

const authStore = useAuthStore();

const activeRoute = "/";

// Full document navigation, matching ExitModal: dropping every store on logout is what stops the
// next person on this device seeing the previous student's cached data. `auth` was not a route
// that exists, so this used to throw and leave the user sitting on the authenticated page.
const logout = () => {
  authStore.logout();
  window.location.replace("/sign-in");
};
</script>
